<template>
  <section class="space-y-4">
    <div class="item-center flex justify-between">
      <h2 class="text-base uppercase text-white/75">
        {{ $t("entities") }}
      </h2>
      <!-- 
        Intents edit disabled as requested in https://holocronit.atlassian.net/browse/LORY2024-132
        <BaseButton :outline="true" size="xs" @click="editContext">{{
          $t("edit")
        }}</BaseButton> 
      -->
    </div>
    <pre>
      <code ref="codeBlock" class="json max-h-[24rem]" v-html="formattedJson"></code>
    </pre>
  </section>
</template>

<script setup>
import useModalStore from "@/stores/modal";
import { useI18n } from "vue-i18n";
import IntentEntitiesForm from "./IntentEntitiesForm.vue";
import { ref, onMounted, watch, computed, nextTick } from "vue";
import hljs from "highlight.js/lib/core";
import json from "highlight.js/lib/languages/json";
import "highlight.js/styles/vs2015.css"; // pick a theme

hljs.registerLanguage("json", json);

const props = defineProps({
  id: {
    type: Number,
    required: true,
  },
  entities: {
    type: Object,
    default: () => ({}),
  },
});

const { openModal } = useModalStore();
const { t } = useI18n();
const currentEntities = ref(props.entities);

const codeBlock = ref(null);

const formatJson = (data) =>
  typeof data === "string"
    ? JSON.stringify(JSON.parse(data), null, 2)
    : JSON.stringify(data, null, 2);

const formattedJson = computed(() => formatJson(currentEntities.value));

const highlight = () => {
  if (codeBlock.value) {
    delete codeBlock.value.dataset.highlighted; // remove previous mark
    hljs.highlightElement(codeBlock.value);
  }
};

onMounted(highlight);

// re-highlight when JSON changes
watch(formattedJson, async () => {
  await nextTick(); // wait for DOM update
  highlight();
});

/**
 * open edit context modal
 */
// Intents edit disabled as requested in https://holocronit.atlassian.net/browse/LORY2024-132
// function editContext() {
//   openModal({
//     title: t("editContext"),
//     component: IntentEntitiesForm,
//     props: {
//       intentID: props.id,
//       entities: currentEntities.value,
//       setEntities: (entities) => {
//         currentEntities.value = entities;
//       },
//     },
//   });
// }
</script>

<style scoped>
pre code.hljs {
  padding: 0.5rem;
  margin: 0;
  line-height: 1.4;
  border-radius: 6px;
  font-size: 0.85rem;
}
</style>
